export function Clipboard() {
    document.addEventListener('click', (evt) => {
        if (!evt.target.dataset.copy) {
            return
        }

        addToClipboard(evt.target)
    })
}

function addToClipboard(button) {
    const text = button.dataset.copy

    if (button.dataset.active) {
        button.removeAttribute('data-active')
    }

    const textArea = document.createElement('textarea')
    textArea.classList.add('u-visually-hidden')

    document.body.appendChild(textArea)

    textArea.value = text
    textArea.select()
    document.execCommand('copy')

    requestAnimationFrame(() => {
        textArea.remove()
        button.dataset.active = true
    })
}
